export const PAGES = [
  { label: 'Home', path: '/home' },
  { label: 'About us', path: '/about-us' },
  { label: 'Safety Info', path: '/safety-info' },
  { label: 'Feedback', path: '/feedback' }
];
